import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-fleetdiag-failure-risk',
  templateUrl: './fleetdiag-failure-risk.component.html',
  styleUrls: ['./fleetdiag-failure-risk.component.css', '../../../../fleetdiag-dashboard-pro.component.scss', '../fleetdiag-health-report/fleetdiag-health-report.component.css']

})

export class FleetdiagFailureRiskComponent implements OnInit {

  report: any = {};

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    tiGroup: new FormControl(''),
    strUnitID: new FormControl(''),
    iFleetDiag_SystemUser: new FormControl(''),
    source: new FormControl(''),
  });

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.parent?.parent?.parent?.params['id'];

    const isFleetUser = id.length < 15 && id.length > 3;
    const controlName = isFleetUser ? 'iFleetDiag_SystemUser' : 'strUnitID';

    this.searchForm.patchValue({
      [controlName]: id,
      source: isFleetUser ? 'users' : 'car-info'
    });

    this.fetchData().catch(err => {
      this._tooltip.showError('خطا در دریافت داده‌ها');
      console.error(err);
      this._otherService.nonespinner();
    });

  }

  async fetchData() {

    this._otherService.Showspinner()

    const model = this._otherService.stringNumberToNumber(this.searchForm.value);
    const endpoint = this.searchForm.value.source === 'users' ? '' : 'FleetDiag_FailureRiskBystrUnitID';

    const response = JSON.parse((await axios.post(endpoint, model)).data.toString());

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'ELM-OBD2' } });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    this.report = response[0];

  }

}